import { useState } from "react";
import { SHIPPING_COSTS } from "../../classes/Enum";
import { getDisplayPrice } from "../../helper/products";

const HOLD = {
      id: SHIPPING_COSTS.HOLD,
      label: '$' + Number(getDisplayPrice(SHIPPING_COSTS.HOLD)),
      title: "Shipping Already Paid",
      description:
        "Use this option if shipping has already been paid in a previous open order.",
      disclaimer:
        "Disclaimer: We will not ship if shipping has not been paid by a previous open order.",
      price: SHIPPING_COSTS.HOLD,
    };

const STANDARD_LOCAL = {
      id: SHIPPING_COSTS.STANDARD,
      label: '$' + Number(getDisplayPrice(SHIPPING_COSTS.STANDARD)),
      title: "Standard Tracked",
      description: "Tracked shipping with standard delivery time.",
      price: SHIPPING_COSTS.STANDARD,
};

const STANDARD_INTERNATIONAL = {
      id: SHIPPING_COSTS.INTERNATIONAL,
      label: '$' + Number(getDisplayPrice(SHIPPING_COSTS.INTERNATIONAL)),
      title: "Int Tracked",
      description: "Tracked international shipping",
      price: SHIPPING_COSTS.INTERNATIONAL,
    };


const EXPRESS_LOCAL = {
      id: SHIPPING_COSTS.EXPRESS,
      label: '$' + Number(getDisplayPrice(SHIPPING_COSTS.EXPRESS)),
      title: "Express Tracked",
      description: "Tracked express shipping with priority handling.",
      price: SHIPPING_COSTS.EXPRESS,
};

function getShippingOptions(country) {
  if (!country) { return [];}
  if (country.toUpperCase() === "AU") {
    return [HOLD, STANDARD_LOCAL, EXPRESS_LOCAL];
  } else {
    return [HOLD, STANDARD_INTERNATIONAL];
  }
}

export default function ShippingOptions({ value, onSelect, country }) {
  const [selected, setSelected] = useState(value);

  const handleSelect = (option) => {
    setSelected(option.id);
    onSelect({shippingCost: option.id});
  };

  let shippingOptions = getShippingOptions(country);

  return (
    <div className="checkout-section">
      <h2>2. Shipping</h2>

      {country && (
        <>
        <div className="shipping-grid">
          {shippingOptions.map((option) => (
            <button
              key={option.id}
              className={`shipping-card ${
                (selected === option.id) ? "selected is-active" : ""
            }`}
            onClick={() => handleSelect(option)}
            >
              <div className="shipping-price">{option.label}</div>
              <div className="shipping-info">
                <div className="shipping-name">{option.title}</div>
                <div className="shipping-description">{option.description}</div>
              </div>
            </button>
          ))}
        </div>
        {(selected === HOLD.id) && (
          <p className="shipping-disclaimer">
            Disclaimer: We will not ship if shipping has not been paid by a
            previous open order.
          </p>
        )}
        </>
      )}
    </div>
  );
}
